import { Pipe, PipeTransform } from '@angular/core';
import { IPoint, IRectangle } from 'ngx-mat-esign360';

@Pipe({
  name: 'boundingBox',
})
export class BoundingBoxPipe implements PipeTransform {
  transform({ topLeft, bottomRight }: { topLeft: IPoint; bottomRight: IPoint }): IRectangle {
    return {
      x: topLeft.x,
      y: topLeft.y,
      width: bottomRight.x - topLeft.x,
      height: bottomRight.y - topLeft.y,
    };
  }
}
